import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import TableImage from "../../../../Componets/Image";
import Status from "../../../../Componets/Status";
import ActionButton from "../../../../Componets/Buttons/action";
import Table from "../../../../Componets/Table";
import {
  create_products_csv,
  get_all_products,
} from "../../../../Controllers/Products/Products";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Importexport/Products/tables";
import headers from "../../../../Data/Tables/Importexport/Products/headers";
import Loadercomponent from "../../../../Componets/Loader";
import ValueTag from "../../../../Componets/Valuetag";
import { useLocation } from "react-router-dom";
import { download_all_products_reports_csv } from "../../../../Controllers/Dashboard/Dashboard";
import Modal from "antd/es/modal/Modal";
import { Button, Input, Spin } from "antd";
import { DownloadOutlined, UploadOutlined } from "@ant-design/icons";

const ProductsImportExportTable = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState();

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const paginationdata = (data) => {
    let headerdata = {};

    header?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      unit: headerdata?.unit,
      category: headerdata?.category,
      brand: headerdata?.brand,
      type: headerdata?.type,
      status: headerdata?.status,
    });
  };

  const formdata = (data) => {
    let page = data?.search ? pagination?.currentPage : 1;

    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const actiondata = (data) => {
    let headerdata = {};
    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      unit: headerdata?.unit,
      category: headerdata?.category,
      brand: headerdata?.brand,
      type: headerdata?.type,
      status: headerdata?.status,
      currentPage: pagination?.currentPage,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        unit: tabledata?.unit,
        category: tabledata?.category,
        brand: tabledata?.brand,
        type: tabledata?.type,
        status: tabledata?.status,
        page: tabledata?.currentPage,
      };

      // let headerdata = [];
      // header?.components?.map((v, i) => {
      //   headerdata?.push({
      //     ...v,
      //     value: data[v?.name],
      //   });
      // });
      // setHeader({ ...header, components: headerdata });

      const products = await get_all_products(data);
      if (products?.status) {
        let data = [];

        products?.data?.data?.map((value, index) => {
          data?.push({
            Name: <TableImage image={value?.image} name={value?.name} />,
            Unit: value?.unit?.name,
            Category: value?.category?.name,
            Brand: value?.brand?.name,
            Stock: (
              <ValueTag
                type={value?.type}
                stock={value?.stock}
                inventory={
                  Number.isInteger(value?.total_inventory)
                    ? parseFloat?.(value?.total_inventory || 0)
                    : parseFloat?.(value?.total_inventory || 0)?.toFixed(3)
                }
              />
            ),
            Status: <Status status={value?.status} />,
            Action: (
              <ActionButton
                edit={`/app/products/edit/${value?._id}`}
                id={value?._id}
                api="delete-product"
                actiondata={actiondata}
                headers={header}
              />
            ),
          });
        });

        setPagination({
          currentPage: products?.data?.currentPage,
          totalCount: products?.data?.totalCount,
          totalPages: products?.data?.totalPages,
        });

        setBody(data);
        setLoader(false);
      } else {
        toast?.error(products?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  const headerReset = () => {
    let componentData = [];
    headers?.components?.map((value, index) => {
      componentData?.push({
        ...value,
        value: null,
      });
    });
    setHeader({ ...headers, components: componentData });
  };

  useEffect(() => {
    fetchData();
    headerReset();
  }, []);

  const [open, setOpen] = useState(false);
  const [exportLoader, setExportLoader] = useState(false);

  const handleImport = async () => {
    setOpen(!open);
  };

  const handledownload = async () => {
    const dashboard = {
      search: "",
      sort: 1,
      unit: null,
      category: null,
      brand: null,
      type: null,
      status: 1,
    };

    setExportLoader(true);

    const blob = await download_all_products_reports_csv(dashboard);

    if (blob) {
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "products.csv");
      document.body.appendChild(link);
      link.click();
      link.remove();
      setExportLoader(false);
    } else {
      setExportLoader(false);
      toast?.error("Failed to export");
    }
  };

  const [file, setFile] = useState();
  const [buttonLoader, setButtonLoader] = useState(false);

  const handleFile = (e) => {
    setFile(e?.target?.files[0]);
  };

  const handleImportSave = async () => {
    if (file) {
      setButtonLoader(true);

      let data = {
        file: file,
      };

      const products = await create_products_csv(data);

      if (products?.status) {
        toast?.success(products?.message);
        setButtonLoader(false);
        setOpen(false);
        setFile(null);
        fetchData();
      } else {
        toast?.error(products?.message + " " + (products?.error || ""));
        setButtonLoader(false);
      }
    } else {
      toast?.error("Select file");
    }
  };

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <div className="mt-4">
          <Modal
            closable={false}
            open={open}
            footer={false}
            onCancel={handleImport}
          >
            <div>
              <div className="pb-3 text-medium">Import</div>
              <Input type="file" onChange={handleFile} accept=".csv"/>
              <div className="pt-4 flex justify-end">
                <Button
                  className="form-cancel-button"
                  disabled={buttonLoader}
                  onClick={handleImport}
                >
                  Cancel
                </Button>
                {/* &nbsp; &nbsp; &nbsp; */}
                <Button
                  className="form-save-button ml-3"
                  onClick={handleImportSave}
                  disabled={buttonLoader}
                >
                  {buttonLoader ? (
                    <Spin tip="Loading" size="large" />
                  ) : (
                    "Import"
                  )}
                </Button>
              </div>
            </div>
          </Modal>
          <div className="flex justify-end mb-4">
            <div>
              <Button className="download-button" onClick={handleImport}>
                <UploadOutlined />
                Import
              </Button>
            </div>
            <div className="pl-2">
              <Button
                className="download-button"
                onClick={handledownload}
                disabled={exportLoader}
              >
                {exportLoader ? (
                  <Spin tip="Loading" className="w-full" />
                ) : (
                  <>
                    <DownloadOutlined />
                    &nbsp;Export
                  </>
                )}
              </Button>
            </div>
          </div>
        </div>
        <Table
          head={tables}
          body={body}
          pagination={pagination}
          paginationdata={paginationdata}
          summary={1}
        />
      </Loadercomponent>
    </Header>
  );
};

export default ProductsImportExportTable;
